import { render, staticRenderFns } from "./SectionCostForDates.vue?vue&type=template&id=5168de7b&scoped=true&"
import script from "./SectionCostForDates.vue?vue&type=script&lang=js&"
export * from "./SectionCostForDates.vue?vue&type=script&lang=js&"
import style0 from "./SectionCostForDates.vue?vue&type=style&index=0&id=5168de7b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5168de7b",
  null
  
)

export default component.exports